import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { COMMON_API } from "../../commonAPI";

const EditLoanDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = sessionStorage.getItem("authToken");

  const [formData, setFormData] = useState({
    loan_id: "",
    main_title: "",
    main_sub_title: "",
    home_desc: "",
    loan_desc: "",
    main_desc: "",
    seo_title: "",
    seo_desc: "",
    seo_tag: "",
  });

  const [loanImgPreview, setLoanImgPreview] = useState(null);
  const [mainImgPreview, setMainImgPreview] = useState(null);

  const [loanImgFile, setLoanImgFile] = useState(null);
  const [mainImgFile, setMainImgFile] = useState(null);

  // Fetch existing loan detail
  const fetchLoanDetail = async () => {
    try {
      const res = await axios.get(
        `${COMMON_API}/loan/getSingleLoanDetails/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (res.data.success) {
        const d = res.data.data;
        setFormData({
          loan_id: d.loan_id || "",
          main_title: d.main_title || "",
          main_sub_title: d.main_sub_title || "",
          home_desc: d.home_desc || "",
          loan_desc: d.loan_desc || "",
          main_desc: d.main_desc || "",
          seo_title: d.seo_title || "",
          seo_desc: d.seo_desc || "",
          seo_tag: d.seo_tag || "",
        });
        if (d.loan_img)
          setLoanImgPreview(`${COMMON_API}/ImgUploads/${d.loan_img}`);
        if (d.main_img)
          setMainImgPreview(`${COMMON_API}/ImgUploads/${d.main_img}`);
      }
    } catch (err) {
      console.error("Error fetching loan detail:", err);
    }
  };

  useEffect(() => {
    fetchLoanDetail();
  }, [id]);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleLoanImgChange = (e) => {
    const selected = e.target.files[0];
    setLoanImgFile(selected);
    if (selected) setLoanImgPreview(URL.createObjectURL(selected));
  };

  const handleMainImgChange = (e) => {
    const selected = e.target.files[0];
    setMainImgFile(selected);
    if (selected) setMainImgPreview(URL.createObjectURL(selected));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const fd = new FormData();
      Object.keys(formData).forEach((key) => {
        fd.append(key, formData[key]);
      });
      if (loanImgFile) fd.append("loan_img", loanImgFile);
      if (mainImgFile) fd.append("main_img", mainImgFile);

      const res = await axios.put(
        `${COMMON_API}/loan/editLoanDetails/${id}`,
        fd,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.success) {
        alert("Loan details updated successfully!");
        navigate(`/loan-details`);
      }
    } catch (err) {
      console.error("Error updating loan detail:", err);
      alert("Failed to update loan details.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-3xl mx-auto bg-white shadow-lg rounded-2xl p-6">
        <h2 className="text-2xl font-bold mb-4">Edit Loan Details</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Loan ID */}
          <input
            type="text"
            name="loan_id"
            value={formData.loan_id}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            placeholder="Loan ID"
          />

          {/* Main Title */}
          <input
            type="text"
            name="main_title"
            value={formData.main_title}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            placeholder="Main Title"
          />

          {/* Main Sub Title */}
          <input
            type="text"
            name="main_sub_title"
            value={formData.main_sub_title}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            placeholder="Main Sub Title"
          />

          {/* Descriptions */}
          <textarea
            name="home_desc"
            value={formData.home_desc}
            onChange={handleChange}
            rows="2"
            className="w-full border px-3 py-2 rounded"
            placeholder="Home Description"
          ></textarea>

          <textarea
            name="loan_desc"
            value={formData.loan_desc}
            onChange={handleChange}
            rows="2"
            className="w-full border px-3 py-2 rounded"
            placeholder="Loan Description"
          ></textarea>

          <textarea
            name="main_desc"
            value={formData.main_desc}
            onChange={handleChange}
            rows="2"
            className="w-full border px-3 py-2 rounded"
            placeholder="Main Description"
          ></textarea>

          {/* SEO Fields */}
          <input
            type="text"
            name="seo_title"
            value={formData.seo_title}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            placeholder="SEO Title"
          />
          <textarea
            name="seo_desc"
            value={formData.seo_desc}
            onChange={handleChange}
            rows="2"
            className="w-full border px-3 py-2 rounded"
            placeholder="SEO Description"
          ></textarea>
          <textarea
            name="seo_tag"
            value={formData.seo_tag}
            onChange={handleChange}
            rows="2"
            className="w-full border px-3 py-2 rounded"
            placeholder="SEO Tags"
          ></textarea>

          {/* Loan Image */}
          <div>
            <label className="block text-sm font-semibold">Loan Image</label>
            {loanImgPreview && (
              <img
                src={loanImgPreview}
                alt="Loan Preview"
                className="w-48 h-32 rounded mb-2"
              />
            )}
            <input type="file" accept="image/*" onChange={handleLoanImgChange} />
          </div>

          {/* Main Image */}
          <div>
            <label className="block text-sm font-semibold">Main Image</label>
            {mainImgPreview && (
              <img
                src={mainImgPreview}
                alt="Main Preview"
                className="w-48 h-32 rounded mb-2"
              />
            )}
            <input type="file" accept="image/*" onChange={handleMainImgChange} />
          </div>

          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Update
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditLoanDetails;
